module.exports = __webpack_public_path__ + "media/images/favicons/favicon-thursday-32x32-5e838008957fac31a6b5f579ee6b189e.png";